module.exports = __webpack_public_path__ + "media/bleak_hallucination.03ede1a4.webm";